// Map InputFields to DatoCMS _modelApiKey
export enum INPUT_FIELDS {
  "InputText" = "input_text",
  "InputSelect" = "input_select",
  "InputCheckbox" = "input_checkbox",
  "InputUploadCv" = "input_upload_cv"
}
